import { Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import dispatchEvent, { eventsToDispatch } from 'helpers/events';
import React, { useState } from 'react';
export const loginValidationAPI = (username: $TSFixMe, password: $TSFixMe) => {
    return axios.post(
        `https://api.auth.${process.env.REACT_APP_ENVIRONMENT}.quincus.com/api/v1/users/login`,
        { username, password },
        {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    );
};
const useStyles = makeStyles(() => ({
    spaceBetween: {
        paddingLeft: 20,
        paddingRight: 20,
        marginTop: 20
    },
    form: {
        width: '100%',
        marginTop: 100
    },
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: 450,
        margin: '0 auto'
    }
}));
const LoginView = ({ isLoggedIn, history }: $TSFixMe) => {
    const classes = useStyles();

    if (isLoggedIn) {
        history.push('/');
    }
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const loginClick = () => {
        loginValidationAPI(username, password)
            .then((e) => {
                window.localStorage.setItem('loginToken', e.data.token);
                setTimeout(() => dispatchEvent(eventsToDispatch.LOGIN_SUCCESS, e.data), 0);
            })
            .catch((e) => {
                console.log(e);
            });
    };
    return (
        <div className={classes.root}>
            <div className={classes.form}>
                <div className={classes.spaceBetween}>
                    <TextField
                        type="text"
                        helperText="username"
                        fullWidth={true}
                        name="username"
                        onChange={(e) => {
                            setUsername(e.target.value);
                        }}></TextField>
                </div>
                <div className={classes.spaceBetween}>
                    <TextField
                        type="password"
                        fullWidth={true}
                        name="password"
                        helperText="password"
                        onChange={(e) => {
                            setPassword(e.target.value);
                        }}></TextField>
                </div>
                <div className={classes.spaceBetween}>
                    <Button
                        data-cy="login-btn"
                        fullWidth={true}
                        variant="contained"
                        color="primary"
                        onClick={loginClick}>
                        Login
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default LoginView;
